// src/store/draft/reducer.js

import * as actionTypes from "../actionTypes";

const initialState = {
  draftPackages: null,
  draftRegistrations: null,
  myDraftRegistrations: null,
  pendingCancellations: null,
  checkoutData: null,
  isLoading: false,
};

const draftReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.SET_DRAFT_LOADING:
      return { ...state, isLoading: action.payload };

    case actionTypes.GET_DRAFT_PACKAGES:
      return { ...state, draftPackages: action.payload };

    case actionTypes.ADD_DRAFT_PACKAGE:
    case actionTypes.UPDATE_DRAFT_PACKAGE:
    case actionTypes.DELETE_DRAFT_PACKAGE:
      return { ...state };

    case actionTypes.INITIATE_DRAFT_REGISTRATION:
      return { ...state, checkoutData: action.payload };

    case actionTypes.GET_DRAFT_REGISTRATIONS:
      return { ...state, draftRegistrations: action.payload };

    case actionTypes.GET_MY_DRAFT_REGISTRATIONS:
      return { ...state, myDraftRegistrations: action.payload };

    case actionTypes.GET_PENDING_CANCELLATIONS:
      return { ...state, pendingCancellations: action.payload };

    case actionTypes.REQUEST_DRAFT_CANCELLATION:
    case actionTypes.UPDATE_PLAYER_RATING:
      return { ...state };

    case actionTypes.CLEAR_CHECKOUT_URL:
      return { ...state, checkoutData: null };

    default:
      return state;
  }
};

export default draftReducer;
